// extracted by mini-css-extract-plugin
module.exports = {"drop":"drop__6UUiL","drop--overlayed":"drop--overlayed__JT4ny","drop--dragover":"drop--dragover__2EYfW","fadein":"fadein__1UAhl","drop__input":"drop__input__2o6so"};